var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","text":"","rounded":"","outlined":"","to":{ name: 'ToolProcessView', params: { name: _vm.toolname }}}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("fas fa-cog")]),_vm._v(" "+_vm._s(_vm.toolname)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }